import config from 'config';

import { Box, useTheme } from '@chakra-ui/react';

import { useAppSelector } from 'store/hooks';

import { LocationFlowType } from 'types';

import { Text } from 'ui';

const {
  header: { shoppingCartType },
  login: {
    loginToContinue: {
      bookingAppointments,
      giftCardPurchase,
      packagePurchase,
      productPurchase,
      membershipPurchase
    }
  }
} = config;

const RedirectedMessage = () => {
  const {
    colors: {
      palette: {
        auth: { login }
      }
    }
  } = useTheme();
  const { redirectFlow } = useAppSelector((state) => state.user);

  const renderRedirectedMessage = () => {
    switch (redirectFlow) {
      case LocationFlowType.BOOK:
        return bookingAppointments;
      case LocationFlowType.GIFT_CARDS:
        return giftCardPurchase;
      case LocationFlowType.PACKAGES_PROMO:
        return packagePurchase;
      case LocationFlowType.PACKAGES:
        return packagePurchase;
      case LocationFlowType.MEMBERSHIPS:
        return membershipPurchase;
      case LocationFlowType.PRODUCT:
        return productPurchase;
      case LocationFlowType.BASKET:
        return `To see your ${shoppingCartType} please, sign in to your account or register`;
      default:
        return '';
    }
  };
  const redirectedMessage = renderRedirectedMessage();

  return redirectedMessage ? (
    <Box
      py={{ base: '18px', sm: '25px', md: '30px', lg: '28px' }}
      px={{ base: '15px', sm: '25px', md: '35px', lg: '28px' }}
      mx={{ base: '0', xl: '-60px' }}
      // mt=
      mb={{ base: '25px', md: '30px', lg: '44px' }}
      borderRadius='6px'
      bg={login.redirectedMessageBg}
    >
      <Text
        fontSize={{ base: '16px', md: '18px', lg: '20px' }}
        color={login.redirectedMessageColor}
        fontWeight='semibold'
        textAlign='center'
      >
        {redirectedMessage}
      </Text>
    </Box>
  ) : null;
};

export default RedirectedMessage;
